import { hydraUiApi, useHydraUIAPIQuery } from '@/services/api';
import { useStore } from '@nanostores/react';
import { AccountFeatureFlag, useFeatureFlag } from '@/services/auth/feature-flags';
import { userStore } from '@/services/auth/store';
import { hasProductionDevHelperAccess, shouldShowDevHelper } from './store';

export function useDevHelperAccess(): boolean {
  const user = useStore(userStore);
  const isFeatureEnabled = useFeatureFlag(AccountFeatureFlag.DeveloperToolsPanel);
  return shouldShowDevHelper(hasProductionDevHelperAccess({ email: user?.email, isFeatureEnabled }));
}

export function useDevHelperFeatureFlags(accountId: number | undefined, enabled = true) {
  return useHydraUIAPIQuery({
    queryKey: ['getFeatureFlags', accountId],
    queryFn: ({ signal }) =>
      hydraUiApi.accounts.getFeatureFlags({ params: { path: { account_id: String(accountId!) } }, signal }),
    queryConfig: {
      enabled: enabled && accountId != null,
      select: (data) => data.featureFlags ?? {},
    },
  });
}
